/** Values the `status` query parameter accepts. Deliberately a wider set than
 *  ActionStatus: `resolved` matches an action with any resolution row, live or
 *  reverted, which is what the Completed tab needs. */
export enum ActionStatusFilter {
    pending = 'pending',
    completed = 'completed',
    reverted = 'reverted',
    resolved = 'resolved',
    all = 'all',
}
